import React from 'react';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button
} from 'reactstrap';

function LetterConfirmationModal(props) {

    return (
        <Modal isOpen={props.open} toggle={props.toggle}>
            <ModalHeader>
                Email Confirmation
            </ModalHeader>
            <ModalBody>
                <div>
                    Are you sure you want to send emails.
                </div>
            </ModalBody>
            <ModalFooter>
                <Button color="danr-red" onClick={props.decline}><span>No</span></Button>
                <Button color="danr-green" onClick={props.accept}><span>Yes</span></Button>
            </ModalFooter>
        </Modal>
    );
}

export default LetterConfirmationModal;